<template>
  <div>
    <div>
      <el-input v-model="search" placeholder="Buscar por título"/>
    </div>
    <br>
    <el-row>
      <el-col :md="16">
        <p>
          <b>{{currentRow.title? 'Procedimiento: '+currentRow.title : 'Seleccione procedimiento.'}}</b>
        </p>
      </el-col>
      <el-col :md="8" align="right">
        <el-button type="primary" @click="clear()" :disabled="!currentRow.id">
          <b>{{$t('Limpiar selección')}}</b>
        </el-button>
      </el-col>
    </el-row>
    <el-table
      v-loading="findStandars"
      height="400"
      ref="singleTable"
      :data="procedures.filter(data => !search || data.title.toLowerCase().includes(search.toLowerCase()))"
      style="width: 100%; border: 10px; border-collapse: separate;"
      :row-class-name="() => 'rowClassTablaPlomaInventarioTarea'"
      header-cell-class-name="header-cell-class-table-gray">

      <el-table-column :label="$t('')" width="30px">
        <template slot-scope="scope">
          
            <el-checkbox size="small" :value="currentRowId === scope.row.id" @change="setCurrent(scope.row)"/>
          
        </template>
      </el-table-column>

      <el-table-column :label="$t('Código')" width="170px"><!-- align="center" -->
        <template slot-scope="scope">
          <div @click="setCurrent(scope.row)">{{scope.row.serial}}</div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Título')">
        <template slot-scope="scope">
          <div @click="setCurrent(scope.row)">{{scope.row.title}}</div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Ver')" width="50px" align="left">
        <template slot-scope="scope">
          <a :href="scope.row.pdf_document" target="_blank">
            <img class="img_pdf" src="@/assets/icons/text-documents_orange.svg"/>
          </a>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import {
  getProcedures,
  addInventoryData,
  editInventoryData,
} from '@/procedures/requests.js';
const getManagements = (areas) => areas && areas.length ? areas.filter(a => a.area_padre && !!!a.area_padre.area_padre): [];
import { mapActions } from "vuex";

export default {
  props: {
    selectedStandarProcedures: {
      default: () => []
    },
    taskId: '',
    contract: {
      default:() => { return {}}
    },
    close: false,
  },
  data() {
    return {
      findStandars: true,
      search: '',
      currentRowId: null,
      procedures: [],
    };
  },
  computed: {
    faenas() { return this.$store.getters.faenas},
    contractId() { return this.contract._id},
    currentAreaId() { return this.contract.area_id },
    currentArea() { return this.areas.find(a => a._id === this.currentAreaId)},
    areas() { return this.$store.getters.areas },
    currentRow() {
      if (!this.currentRowId) return {};
      return this.procedures.find(p => p.id === this.currentRowId) || {}
    },
    inventory_data() { // registro en la tabla de procedimiento que asocia proc standar con la tarea
      return this.selectedStandarProcedures.find(f => f.task_id === this.taskId)
    },
    managements(){ return getManagements(this.areas) || [] },
    managementsIds(){ return this.managements.map(a => a._id) },
    myManagement(){ return this.findManagement(this.currentArea) || {} },
    myManagementId(){ return this.myManagement._id  },
  },
  watch: {
    close(val) {
      if (val === false) {
        if (! this.currentRowId) return;
        this.save()
        console.log(this.currentRow,'??')
      }
    },
    taskId(val) {
      this.currentRowId = null;
      if (this.inventory_data) this.currentRowId = this.inventory_data.procedure;
    }
  },
  async created() {
    if (this.inventory_data) this.currentRowId = this.inventory_data.procedure;
    if (this.$store.getters.areas.length === 0) {
      await this.getAreasFaena();
    }
    getProcedures({
      is_deleted: false,
      last_version: true,
      is_standard: true,
      job_id: this.$store.getters.role.faena_id,
       //area_id: this.myManagementId,
    })
      .then(r => console.log('p',r) || r)
      .then(r => {
        this.findStandars = false;
        if (r.length) {
          this.procedures = r.filter(p => {
            const a = this.findArea(p.area_id);
            const m = this.findManagement(a);
            if (!m._id) console.error(`problema con este registro`,p);

            return m._id === this.myManagementId;
          });
          console.log(this.procedures)
        }
      })
      .catch(e => {
        console.error(e);
        this.findStandars = false;
      });
  },
  methods: {
    ...mapActions(["getAreasFaena"]),
    findManagement(a){
      if (!a) return {};
      if (this.managementsIds.includes(a._id)) return a;
      if (a.area_padre) return this.findManagement(a.area_padre);
      console.log('no se encontro management de ',a)
      return {};
    },
    findArea(id){
      return this.areas.find(a => a._id === id) || {}
    },
    setCurrent(val) {
      this.currentRowId = this.currentRowId === val.id ? this.clear() : val.id;
    },
    clear() {
      this.currentRowId = null;
      if (this.inventory_data.id) this.save();
    },
    save() {
      const save = this.inventory_data || {task_id: this.taskId, inventory_id: this.contractId};
console.log('save', save)
      const method = save.id ? editInventoryData : addInventoryData;

      save.procedure = this.currentRowId;

      method(save)
        .then(r => console.log(r) || r)
        .then(r => {
          if (r.id) {
            save.id
              ? save.id = r.id
              : this.selectedStandarProcedures.push(r);
          } else {
            console.error(r)
          } // if
        })
        .catch(e => console.error(e));
    }
  },
};
</script>

<style scoped>
.img_pdf{
  height: 30px;
  margin-bottom: 5px;
}
</style>
